import { TableCell, TableRow } from '@/components/ui/table'
import { BALANCE_HISTORY_TYPE_LABELS } from '@/config/profile'
import { formatDisplayDate } from '@/lib/format-date'
import { formatBalance, formatSignedAmount } from '@/lib/format-number'
import { cn } from '@/lib/utils'
import { CurrencyIcon } from '@/components/profile/CurrencyIcon'
import type { BalanceHistoryItem } from '@/types/payment'

function getAmountTone(amount: string) {
	const numericAmount = Number.parseFloat(amount)

	if (numericAmount > 0) {
		return 'text-success'
	}

	if (numericAmount < 0) {
		return 'text-destructive'
	}

	return 'text-muted-foreground'
}

export function TransactionRow({ transaction }: { transaction: BalanceHistoryItem }) {
	const currency = transaction.currency
	const typeLabel = BALANCE_HISTORY_TYPE_LABELS[transaction.type] ?? transaction.type

	return (
		<TableRow className='border-border/60 hover:bg-accent/30'>
			<TableCell className='whitespace-nowrap px-3 py-3 sm:px-4'>
				<div className='flex items-center gap-2'>
					<CurrencyIcon code={transaction.currency_code} symbolUrl={currency?.symbol_url} size='sm' />
					<span className='font-semibold text-foreground'>{currency?.currency_code ?? transaction.currency_code}</span>
				</div>
			</TableCell>
			<TableCell className='whitespace-nowrap px-3 py-3 text-xs text-muted-foreground sm:px-4 sm:text-sm'>{typeLabel}</TableCell>
			<TableCell className={cn('whitespace-nowrap px-3 py-3 text-xs font-semibold sm:px-4 sm:text-sm', getAmountTone(transaction.amount))}>
				{formatSignedAmount(transaction.amount)}
			</TableCell>
			<TableCell className='hidden whitespace-nowrap px-3 py-3 text-xs text-muted-foreground sm:table-cell sm:px-4 sm:text-sm'>
				{formatBalance(transaction.before_balance)}
			</TableCell>
			<TableCell className='hidden whitespace-nowrap px-3 py-3 text-xs text-muted-foreground sm:px-4 sm:text-sm md:table-cell'>
				{formatBalance(transaction.after_balance)}
			</TableCell>
			<TableCell className='whitespace-nowrap px-3 py-3 text-xs text-muted-foreground sm:px-4 sm:text-sm'>{formatDisplayDate(transaction.created_at)}</TableCell>
		</TableRow>
	)
}
